import React, { useState, useEffect } from 'react';
import { RedocStandalone } from 'redoc';
import { Redirect } from 'react-router-dom';
import { options as redocOptions } from '../ReDocResources/options';
import '../ReDocResources/ReDoc.scss';

export function GasMetersReDoc() {
    const [spec, setSpec] = useState(null);

    const gasMeterApis = window.environment.gasMeterApis;

    const fetchSwaggerFiles = async (urls) => {
        const results = await Promise.allSettled(urls.map(url => fetch(url).then(resp => resp.json())));

        // Filter successful responses and extract their values
        const successfulSpecs = results.filter(result => result.status === 'fulfilled').map(result => result.value);
        return successfulSpecs;
    };

    // Combines multiple Swagger files in one.
    const mergeSwaggerFiles = (files) => {
        
        let baseFile = files.find(file => file && file.paths && Object.keys(file.paths).length);

        if (!baseFile) {
            return <Redirect to='/not-found' />;
        }
        let combined = {
            ...baseFile,
        };

        // Iterate over each Swagger file
        files.forEach((file, index) => {

            // Combine the paths (endpoints)
            if (file.paths && Object.keys(file.paths).length) {
                for (let path in file.paths) {
                    if (!combined.paths[path]) {
                        combined.paths[path] = file.paths[path];
                    }
                }
            }

            // Combine the definitions (models)
            if (file.definitions && Object.keys(file.definitions).length) {
                for (let definition in file.definitions) {
                    if (!combined.definitions[definition]) {
                        combined.definitions[definition] = file.definitions[definition];
                    }
                }
            }

            // Combine the tags. Here we simply add tags if they don't exist in the combined one
            if (file.tags && Object.keys(file.tags).length) {
                file.tags.forEach(tag => {
                    if (!combined.tags.find(t => t.name === tag.name)) {
                        combined.tags = (combined.tags || []).concat(tag);
                    }
                });
            }

            // Combine x-tagGroups
            if (file['x-tagGroups']) {
                file['x-tagGroups'].forEach(tagGroup => {
                    const existingTagGroup = combined['x-tagGroups'].find(tg => tg.name.toLowerCase() === tagGroup.name.toLowerCase());

                    if (existingTagGroup) {
                        // If the tag group already exists, combine the tags
                        tagGroup.tags.forEach(tag => {
                            if (!existingTagGroup.tags.includes(tag)) {
                                existingTagGroup.tags.push(tag);
                            }
                        });
                    } else {
                        // If the tag group doesn't exist, add the whole group
                        combined['x-tagGroups'] = (combined['x-tagGroups'] || []).concat(tagGroup);
                    }
                });
            }
        });

        combined.info = {
            title: 'Storm API',
            description: 'Storm API documentation to provide the necessary details for clients for their own integrations and custom services around the Storm functionality stack.'
        };

        return combined;

    };

    // useEffect takes care of initiating the merging process when the component is mounted
    useEffect(() => {
        const combineSpecs = async () => {
            // Fetch all Swagger files
            const specs = await fetchSwaggerFiles(gasMeterApis);

            // Merge the files
            const combinedSpec = mergeSwaggerFiles(specs);

            // Set the combined spec to local state
            setSpec(combinedSpec);
        };

        combineSpecs();
    }, []);

    if (!spec) {
        return <></>;
    }

    if (Object.keys(spec).length === 0) {
        return <Redirect to='/not-found' />;
    }

    return <RedocStandalone spec={spec} options={redocOptions} />;
}

export default GasMetersReDoc;
